import { getSangjoFuneralDirector } from "@/apis/sangjoReview";
import { SangjoFuneralDirectorProps } from "@/types/sangjoType";
import { Drawer, DrawerContent, DrawerOverlay } from "@chakra-ui/react";
import { css } from "@emotion/react";
import { funeralDirectorState } from "containers/ReviewContainer/remotes/atoms/funeralDirectorState";
import { ColorIcon, colors, HStack, VStack, CircleImage, getCdnImageSrc } from "goi_common";

import { Dispatch, SetStateAction } from "react";
import { useQuery } from "react-query";
import { useRecoilState } from "recoil";

interface BottomSheetProps {
  id: string;
  open: boolean;
  onClose: () => void;
  setCurrentStep: Dispatch<SetStateAction<string>>;
}

export function BottomSheet({ id, open, onClose, setCurrentStep }: BottomSheetProps) {
  const [selected, setSelected] = useRecoilState(funeralDirectorState);
  const { data: funeralDirectors, isLoading } = useQuery<SangjoFuneralDirectorProps[]>(
    ["sangjos", "funeralDirectors", id],
    () => getSangjoFuneralDirector(id),
  );

  return (
    <Drawer
      isOpen={open}
      onClose={() => {
        onClose();
      }}
      placement="bottom"
    >
      <DrawerOverlay color="rgba(0, 0, 0, 0.7)" />
      <DrawerContent
        css={css`
          border-radius: 10px 10px 0px 0px;
          background-color: white;
          width: 100% !important;
          max-width: var(--global-max-width) !important;
          margin-left: var(--left);
          max-height: 450px;
          overflow-y: auto;
        `}
      >
        <VStack
          gap={1}
          css={css`
            background-color: ${colors.gray100};
          `}
        >
          {!isLoading &&
            funeralDirectors &&
            funeralDirectors.map((funeralDirector) => (
              <HStack
                as="button"
                key={funeralDirector.id}
                gap={25}
                alignItems="center"
                justifyContent="space-between"
                onClick={() => setSelected(funeralDirector.id)}
                css={css`
                  padding: 8px 24px;
                  background-color: white;
                `}
              >
                <HStack gap={8}>
                  {funeralDirector.id === selected ? (
                    <ColorIcon
                      name="icon-circle-check-mono"
                      size={24}
                      color={colors.orange650}
                      css={css`
                        flex-shrink: 0;
                      `}
                    />
                  ) : (
                    <ColorIcon
                      name="icon-circle-empty-mono"
                      size={24}
                      color={colors.gray300}
                      css={css`
                        flex-shrink: 0;
                      `}
                    />
                  )}
                  <VStack
                    gap={4}
                    alignItems="flex-start"
                    css={css`
                      text-align: left;
                    `}
                  >
                    <div className="button gray900">{funeralDirector.name} 장례지도사</div>
                    <div
                      className="gray500"
                      css={css`
                        font-size: 12px;
                        line-height: 18px;
                      `}
                    >
                      {funeralDirector.quote}
                    </div>
                  </VStack>
                </HStack>
                <VStack css={{ flexShrink: 0 }}>
                  <CircleImage
                    src={getCdnImageSrc(
                      `images/funeraldirector/${funeralDirector.id}/profile_square.png`,
                    )}
                    radius={60}
                  />
                </VStack>
              </HStack>
            ))}

          <HStack
            gap={12}
            css={css`
              padding: 16px 24px 30px;
              position: sticky;
              bottom: 0;
              background-color: white;
            `}
          >
            <button
              className="button black"
              css={css`
                width: 80px;
                background-color: ${colors.gray100};
                border-radius: 5px;
                padding: 10px 0;
              `}
              onClick={() => {
                setSelected(-1);
                onClose();
              }}
            >
              취소
            </button>
            <button
              className="button white"
              css={css`
                background-color: ${colors.black};
                border-radius: 5px;
                flex: 1;
                padding: 10px 0;
              `}
              onClick={() => {
                if (selected !== -1) {
                  setCurrentStep("POST");
                  onClose();
                } else {
                  alert("장례지도사를 선택해주세요.");
                }
              }}
            >
              선택 완료
            </button>
          </HStack>
        </VStack>
      </DrawerContent>
    </Drawer>
  );
}
